import React, { useState } from 'react';
import { AppBar, Toolbar, Box, Typography, Avatar, Menu, MenuItem, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const Header = ({ userInfo, isAdmin, handleSignOut, startNewConversation, clearChat }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);

  const toggleMenu = (e) => setAnchorEl(anchorEl ? null : e.currentTarget);
  const closeMenu = () => setAnchorEl(null);
  const handleSignOutClick = () => {
    closeMenu();
    handleSignOut(clearChat);
  };

  const toggleMoreMenu = (e) => setMoreAnchorEl(moreAnchorEl ? null : e.currentTarget);
  const closeMoreMenu = () => setMoreAnchorEl(null);

  return (
    <AppBar
      id="app-header"
      position="sticky"
      color="default"
      elevation={0}
      className="header"
      sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', left: 0, right: 0, p: 0 }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: { xs: 48, md: 56 },
          px: { xs: 2, md: 3 },
          width: '100%',
        }}
      >
        <Box className="header-left" sx={{ display: 'flex', alignItems: 'center', gap: { xs: '12px', md: '16px' } }}>
          <Box component="img" src="/images/group-1.svg" alt="DCLI" className="brand-logo-img" sx={{ height: { xs: 20, md: 24 }, display: 'block' }} />
        </Box>

        <Box className="header-controls" sx={{ display: 'flex', alignItems: 'center', gap: { xs: '10px', md: '12px' } }}>
          {/* Three-dot menu for Download, Add People, View People */}
          <IconButton
            onClick={toggleMoreMenu}
            size="small"
            sx={{ color: '#666' }}
            aria-label="More options"
          >
            <MoreVertIcon />
          </IconButton>

          <Menu
            anchorEl={moreAnchorEl}
            open={Boolean(moreAnchorEl)}
            onClose={closeMoreMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem onClick={closeMoreMenu}>Download</MenuItem>
            <MenuItem onClick={closeMoreMenu}>Add people</MenuItem>
            <MenuItem onClick={closeMoreMenu}>View people</MenuItem>
          </Menu>

          <Box
            component="img"
            src="/images/notifications.svg"
            alt="Notifications"
            sx={{
              width: 20,
              height: 20,
              cursor: 'pointer'
            }}
          />
          <Box className="user-menu">
            <Box
              className="username-container"
              onClick={toggleMenu}
              sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
            >
              <Typography className="username" variant="body2" sx={{ fontSize: { xs: 12, md: 13 } }}>{userInfo?.name || 'User'}</Typography>
              <Avatar
                sx={{
                  width: { xs: 26, md: 28 },
                  height: { xs: 26, md: 28 },
                  bgcolor: '#fff',
                  color: '#666',
                  fontSize: { xs: 10, md: 11 },
                  fontWeight: 600,
                  border: '1px solid #e5e5e5',
                }}
              >
                {userInfo?.initials || 'U'}
              </Avatar>
              <Typography className="dropdown-arrow" variant="caption" sx={{ fontSize: { xs: 10, md: 11 } }}>▼</Typography>
            </Box>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={closeMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <Box className="dropdown-item user-info" sx={{ px: 2, py: 1.25 }}>
                <div><strong>{userInfo?.name}</strong></div>
                <small>{userInfo?.email}</small>
                {isAdmin && <div className="admin-badge">Administrator</div>}
              </Box>
              <MenuItem onClick={() => { closeMenu(); startNewConversation(); }}>Start New Conversation</MenuItem>
              <MenuItem onClick={() => { closeMenu(); clearChat(); }}>Clear Chat</MenuItem>
              <MenuItem onClick={() => { closeMenu(); window.downloadHealthLogs?.(); }}>Download Logs</MenuItem>
              <MenuItem onClick={handleSignOutClick}>Sign Out</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
